<script>
export default {
  directives: {
    uppercase: {
      bind(el) {
        el.addEventListener('input', () => {
          el.setAttribute('data-user-input', 'true');
        });
      },
      update(el, binding) {
        const sourceValue = el.getElementsByTagName('input')[0];
        // the inner input can be absent while Vue is re-patching the field
        if (!sourceValue) return;
        let newValue = sourceValue.value;

        // Only capitalize if it's user input and the binding.value is true
        if (binding.value && el.getAttribute('data-user-input') === 'true') {
          newValue = sourceValue.value.toUpperCase();
        }

        if (sourceValue.value !== newValue) {
          const { selectionStart, selectionEnd } = sourceValue;
          sourceValue.value = newValue;
          sourceValue.setSelectionRange(selectionStart, selectionEnd);
          sourceValue.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Reset the user input flag after update
        el.setAttribute('data-user-input', 'false');
      },
    },
    textAreaUppercase: {
      bind(el) {
        el.addEventListener('input', () => {
          el.setAttribute('data-user-input', 'true');
        });
      },
      update(el, binding) {
        const sourceValue = el.getElementsByTagName('textarea')[0];
        // the inner textarea can be absent while Vue is re-patching the field
        if (!sourceValue) return;
        let newValue = sourceValue.value;

        // Only capitalize if it's user input and the binding.value is true
        if (binding.value && el.getAttribute('data-user-input') === 'true') {
          newValue = sourceValue.value.toUpperCase();
        }

        if (sourceValue.value !== newValue) {
          const { selectionStart, selectionEnd } = sourceValue;
          sourceValue.value = newValue;
          sourceValue.setSelectionRange(selectionStart, selectionEnd);
          sourceValue.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Reset the user input flag after update
        el.setAttribute('data-user-input', 'false');
      },
    },
  },
};
</script>
